import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Alert,
    Col,
    Row
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FormAsyncButton } from "../../../components/controls/buttons/AsyncButton";
import { tuLandlordTOS } from '../../../util/FormConstants';
import { CheckBoxField, InputField } from "../../../validation/ReduxFormInput";
import { registerOwner } from "../actions/authentication";


class OwnerReach extends Component {
    render() {
        const {handleSubmit, handleRegister, error, submitting, pristine, invalid} = this.props;

        return (
            <div className="center">
                <h2 className="text-primary">Here's who we found for you</h2>
                <h3>Registered potential tenants:</h3>
                <h2 className="text-success ">{this.props.reach.reach}</h2>
                <hr/>
                {
                    this.props.reach.interest > 0 && (
                        <div>
                            <h3>Tenants interested in this property:</h3>
                            <h2 className="text-success">{this.props.reach.interest}</h2>
                            <hr/>
                        </div>
                    )
                }
                <h4>Create a password to claim this property</h4>
                <form onSubmit={handleSubmit(handleRegister)}>
                    <Row>
                        <Col><Field name="password" label="Password" component={InputField} type="password"/></Col>
                        <Col><Field name="confirm_password" label="Confirm Password" component={InputField} type="password"/></Col>
                    </Row>
                    <br />
                    <p><strong>TransUnion Service Agreement</strong></p>
                    <div style={{height: '220px', overflow: 'auto', border: '1px solid #bbbbbb', borderRadius: '4px', padding: '10px', textAlign: 'left'}}>
                        {tuLandlordTOS}
                    </div>
                    <Field name="FcraAgreementAccepted" label="I agree to the TransUnion Service Agreement above." component={CheckBoxField}/>
                    <br />
                    <FormAsyncButton acting={submitting}
                                     color="success"
                                     type="submit"
                                     outline
                                     block
                                     disabled={pristine || invalid} id="owner_register_button">
                        Claim & Create Account
                    </FormAsyncButton>
                    {
                        error &&
                        <div className="center" style={{marginTop: '5px'}}>
                            <Alert color="danger">
                                {error}
                            </Alert>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

const validate = (values) => {
    const errors = {};

    !values.password && (errors.password = 'Required');
    !values.confirm_password && (errors.confirm_password = 'Required');

    !values.FcraAgreementAccepted && (errors.FcraAgreementAccepted = 'Required');

    (values.confirm_password !== values.password) && (errors.confirm_password = 'Passwords must match!');
    (values.password && values.password.length < 8) && (errors.password = "Must be at least 8 characters");

    return errors;
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, props) => ({
    handleRegister(data) {
        data.first_name = props.owner.first_name;
        data.last_name = props.owner.last_name;
        data.email = props.owner.email;
        data.phone = props.owner.phone;

        return dispatch(registerOwner(data, props.reach.property_id));
    }
});

OwnerReach = reduxForm({
    form: 'owner_reach',
    validate
})(OwnerReach);

export default connect(mapStateToProps, mapDispatchToProps)(OwnerReach);



// WEBPACK FOOTER //
// ./src/containers/authentication/OwnerRegisterFlow/OwnerReach.js